import ApplicationQuestionSwitcher from './application-question-switcher';
import { FormContainer } from '../../../presentation';
import { AnswerType, Question } from '@converge/graphql';
import { transformQuestionsToNestedStructure } from './utils';
import { useMemo } from 'react';

interface IApplicationQuestionProps {
  questions: Question[];
  isApplicationViewOnly: boolean;
  onBlur?: () => void;
  onChange?: (key: string, value: unknown) => void;
  isPrimary?: boolean;
  setRaterError?: boolean;
}

export interface SubmissionApplicationQuestionDetailsExt
  extends Omit<Question, 'type'> {
  level: number;
  groupChildren: SubmissionApplicationQuestionDetailsExt[];
  children: SubmissionApplicationQuestionDetailsExt[];
  isGroup: boolean;
  isSubGroup: boolean;
  subGroupChildren: SubmissionApplicationQuestionDetailsExt[];
  isGroupItem: boolean;
  isSubGroupItem: boolean;
  question?: string | null;
  type: string | null;
  // answer?: { answer?: string | null; uuid: string; type: AnswerType } | null;
}

export interface SubmissionQuestionDetails {
  uuid: string;
  question?: string | null;
  good?: boolean | null;
  type?: string | null;
  graphqlQuery?: string;
  answer?: { answer?: string | null; uuid: string; type: AnswerType } | null;
}

export const ApplicationQuestion = ({
  questions,
  isApplicationViewOnly,
  onBlur,
  onChange,
  isPrimary,
  setRaterError,
}: IApplicationQuestionProps) => {
  const nestedQuestions = useMemo(
    () => transformQuestionsToNestedStructure(questions),
    [questions]
  );
  return (
    <FormContainer>
      {nestedQuestions.map((q) => (
        <ApplicationQuestionSwitcher
          question={q}
          isApplicationViewOnly={isApplicationViewOnly}
          key={q.uuid}
          onBlur={onBlur}
          onChange={onChange}
          isPrimary={isPrimary}
          setRaterError={setRaterError}
        />
      ))}
    </FormContainer>
  );
};

export default ApplicationQuestion;
